export default __webpack_public_path__ + "static/media/7t.69172daa.jpg";